(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var init = function init() {
  var kuvaify = this;
  var element = document.createElement('div');

  var append = function append() {
    element.className = 'kuvaify-close-div';

    kuvaify.overlay.element.appendChild(element);
  };

  var visibility = function visibility(what) {
    if (what === 'visible') {
      element.classList.add('visible');
    }
    if (what === 'hidden') {
      element.classList.remove('visible');
    }
  };

  var click = function click(event) {
    kuvaify.close.close();

    event.preventDefault();
  };

  var addEventListeners = function addEventListeners() {
    element.addEventListener('click', click);
  };

  var removeEventListeners = function removeEventListeners() {
    element.removeEventListener('click', click);
  };

  return {
    append: append,
    visibility: visibility,
    addEventListeners: addEventListeners,
    removeEventListeners: removeEventListeners
  };
};

exports.default = init;

},{}],2:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var init = function init() {
  var kuvaify = this;
  var element = document.createElement('a');

  var append = function append() {
    element.className = 'kuvaify-close-button', element.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50.000001 50.000001"><g stroke="#fff" fill="none" stroke-width="2"><path d="M10 40l30-30M40 40L10 10"/></g></svg>';

    kuvaify.overlay.element.appendChild(element);
  };

  var visibility = function visibility(what) {
    if (what === 'visible') {
      element.classList.add('visible');
    }
    if (what === 'hidden') {
      element.classList.remove('visible');
    }
  };

  var close = function close() {
    if (kuvaify.systemsReady) {
      kuvaify.closed = true;

      kuvaify.overlay.visibility('hidden');
      kuvaify.closeDiv.visibility('hidden');
      kuvaify.img.hide(kuvaify.currentIndex);
      visibility('hidden');
      kuvaify.menu.visibility('hidden');
      kuvaify.navigation.visibility('hidden');
      kuvaify.spinner.visibility('hidden');

      kuvaify.overlay.removeEventListeners();
      kuvaify.closeDiv.removeEventListeners();
      kuvaify.img.removeEventListeners();
      removeEventListeners();
      kuvaify.menu.removeEventListeners();
      kuvaify.reset.removeEventListeners();
      kuvaify.zoom.removeEventListeners();
      kuvaify.rotate.removeEventListeners();
      kuvaify.navigation.removeEventListeners();

      kuvaify.systemsReady = false;
    }
  };

  var click = function click(event) {
    close();

    event.preventDefault();
  };

  var keydown = function keydown(event) {
    if (event.keyCode === 27) {
      click(event);
    }
  };

  var addEventListeners = function addEventListeners() {
    element.addEventListener('click', click);

    window.addEventListener('keydown', keydown);
  };

  var removeEventListeners = function removeEventListeners() {
    element.removeEventListener('click', click);

    window.removeEventListener('keydown', keydown);
  };

  return {
    append: append,
    visibility: visibility,
    close: close,
    addEventListeners: addEventListeners,
    removeEventListeners: removeEventListeners
  };
};

exports.default = init;

},{}],3:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var init = function init() {
  var _this = this;

  var kuvaify = this;
  var images = kuvaify.images;
  var options = kuvaify.options;
  var firefox = navigator.userAgent.indexOf('Firefox') !== -1 ? true : false;

  var href = function href(index) {
    var img = images[index];

    if (img.smallHref && kuvaify.screenWidth < options.smallSize) {
      return img.smallHref;
    }
    if (img.mediumHref && kuvaify.screenWidth < options.mediumSize) {
      return img.mediumHref;
    }

    return img.href;
  };

  var size = function size(index) {
    (function (index) {
      var img = images[index].element;
      var body = kuvaify.body;
      var imgWidth = img.clientWidth;
      var imgHeight = img.clientHeight;

      kuvaify.screenWidth = body.clientWidth;
      kuvaify.screenHeight = body.clientHeight;

      if (imgWidth < kuvaify.screenWidth && imgHeight < kuvaify.screenHeight) {
        if (imgWidth > imgHeight) {
          img.classList.remove('cover-horizontally');
          img.classList.add('cover-vertically');
        } else {
          img.classList.remove('cover-vertically');
          img.classList.add('cover-horizontally');
        }
      } else {
        if (imgWidth < kuvaify.screenWidth) {
          img.classList.remove('cover-vertically');
          img.classList.add('cover-horizontally');
        }
        if (imgHeight < kuvaify.screenHeight) {
          img.classList.remove('cover-horizontally');
          img.classList.add('cover-vertically');
        }
      }
    })(index);
  };

  var visibility = function visibility(what, index) {
    (function (what, index) {
      var img = images[index];

      if (what === 'visible') {
        img.element.classList.add('visible');

        if (img.caption) {
          img.caption.classList.add('visible');
        }
      }
      if (what === 'hidden') {
        img.element.classList.remove('visible');

        if (img.caption) {
          img.caption.classList.remove('visible');
        }
      }
    })(what, index);
  };

  var get = function get(index) {
    (function (index) {
      var img = images[index];
      var overlay = kuvaify.overlay.element;
      var spinner = kuvaify.spinner;

      spinner.visibility('visible');

      overlay.appendChild(img.element);

      img.element.src = href(index);

      if (img.caption) {
        overlay.appendChild(img.caption);
      }

      hide(index);

      img.element.addEventListener('load', function () {
        img.loaded = true;

        if (options.coverScreen) {
          size(index);
        }

        spinner.visibility('hidden');

        if (index === kuvaify.currentIndex && !kuvaify.closed) {
          show(index);
        }
      });
    })(index);
  };

  var show = function show(index) {
    (function (index) {
      var img = images[index];

      setTimeout(function () {
        visibility('visible', index);

        if (options.transitionScale > 0) {
          transform(index, {
            scale: img.scale - options.transitionScale
          });
        }
      }, options.transitionSpeed * options.transitionOverlap);
    })(index);
  };

  var hide = function hide(index) {
    (function (index) {
      var img = images[index];

      visibility('hidden', index);

      if (options.transitionScale > 0) {
        transform(index, {
          scale: img.scale + options.transitionScale
        });
      }
    })(index);
  };

  var prepare = function prepare(index, navigated) {
    var img = images[index];
    var navigation = kuvaify.navigation;
    var spinner = kuvaify.spinner;

    navigation.removeEventListeners();

    if (navigated) {
      removeEventListeners();

      hide(kuvaify.oldIndex);
    }

    kuvaify.setCurrent(index);

    var next = kuvaify.nextIndex;
    var prev = kuvaify.prevIndex;

    if (next) {
      if (!images[next].loaded) {
        get(next);
      }
    }
    if (prev) {
      if (!images[prev].loaded) {
        get(prev);
      }
    }

    addEventListeners();

    if (!img.element.src) {
      get(index);
    } else {
      if (img.loaded) {
        spinner.visibility('hidden');

        show(index);
      } else {
        spinner.visibility('visible');
      }
    }

    setTimeout(function () {
      navigation.visibility('depends');
      navigation.addEventListeners();
    }, options.transitionSpeed / 2);
  };

  var transform = function transform(index, _ref) {
    var _ref$scale = _ref.scale;
    var scale = _ref$scale === undefined ? images[index].scale : _ref$scale;
    var _ref$rotate = _ref.rotate;
    var rotate = _ref$rotate === undefined ? images[index].rotate : _ref$rotate;

    (function (index, scale, rotate) {
      var img = images[index];

      kuvaify.rotate.removeEventListeners();

      var transformString = 'translate(-50%, -50%) scale(' + scale + ') rotate(' + rotate + 'deg)';

      img.scale = scale;
      img.rotate = rotate;
      img.element.style.webkitTransform = transformString;
      img.element.style.msTransform = transformString;
      img.element.style.transform = transformString;

      setTimeout(function () {
        kuvaify.rotate.addEventListeners();
      }, options.transitionSpeed / 2);
    })(index, scale, rotate);
  };

  var reset = function reset(index) {
    var img = images[index];

    img.element.style.transition = img.transition + (', left ' + _this.options.transitionSpeed + 'ms ease, top ' + _this.options.transitionSpeed + 'ms ease');
    img.element.style.left = null;
    img.element.style.top = null;

    setTimeout(function () {
      img.element.style.transition = img.transition;
    }, options.transitionSpeed);

    transform(index, {
      scale: 1,
      rotate: 0
    });
  };

  var click = function click(event) {
    kuvaify.menu.div.classList.remove('visible');

    event.preventDefault();
  };

  var dblclick = function dblclick(event) {
    reset(kuvaify.currentIndex);

    event.preventDefault();
  };

  var wheel = function wheel(event) {
    var img = images[kuvaify.currentIndex];
    var delta = firefox ? event.detail : event.wheelDelta;
    var positive = firefox ? delta < 0 : delta > 0;
    var negative = firefox ? delta > 0 : delta < 0;

    if (positive) {
      img.scale += img.scaleRatio;
    }
    if (negative) {
      if (img.scale >= 0.001) {
        img.scale -= img.scaleRatio;
      }
    }

    transform(kuvaify.currentIndex, {
      scale: img.scale
    });

    event.preventDefault();
  };

  var mousedown = function mousedown(event) {
    var img = images[kuvaify.currentIndex];

    img.offx = event.clientX - img.element.offsetLeft;
    img.offy = event.clientY - img.element.offsetTop;

    window.addEventListener('mousemove', mousemove);

    event.preventDefault();
  };

  var mousemove = function mousemove(event) {
    var img = images[kuvaify.currentIndex];

    var move = function move() {
      img.element.style.left = event.clientX - img.offx + 'px';
      img.element.style.top = event.clientY - img.offy + 'px';
    };

    window.requestAnimationFrame(move);
  };

  var mouseup = function mouseup(event) {
    window.removeEventListener('mousemove', mousemove);
  };

  var addEventListeners = function addEventListeners() {
    var img = images[kuvaify.currentIndex];
    var wheelEvent = firefox ? 'DOMMouseScroll' : 'mousewheel';

    img.element.addEventListener('mousedown', mousedown);
    img.element.addEventListener('click', click);
    img.element.addEventListener('dblclick', dblclick);

    window.addEventListener(wheelEvent, wheel);
    window.addEventListener('mouseup', mouseup);
  };

  var removeEventListeners = function removeEventListeners() {
    var img = images[kuvaify.currentIndex];
    var wheelEvent = firefox ? 'DOMMouseScroll' : 'mousewheel';

    img.element.removeEventListener('mousedown', mousedown);
    img.element.removeEventListener('click', click);
    img.element.removeEventListener('dblclick', dblclick);

    window.removeEventListener(wheelEvent, wheel);
    window.removeEventListener('mouseup', mouseup);
  };

  var resize = function resize(event) {
    images.forEach(function (img) {
      var index = images.indexOf(img);

      size(index);
    });
  };

  var addResizeListener = function addResizeListener() {
    if (options.coverScreen) {
      window.addEventListener('resize', resize);
    }
  };

  addResizeListener();

  return {
    hide: hide,
    prepare: prepare,
    transform: transform,
    reset: reset,
    addEventListeners: addEventListeners,
    removeEventListeners: removeEventListeners,
    addResizeListener: addResizeListener
  };
};

exports.default = init;

},{}],4:[function(require,module,exports){
'use strict';

var _setup = require('./setup');

var _setup2 = _interopRequireDefault(_setup);

var _overlay = require('./overlay');

var _overlay2 = _interopRequireDefault(_overlay);

var _img = require('./img');

var _img2 = _interopRequireDefault(_img);

var _close = require('./close');

var _close2 = _interopRequireDefault(_close);

var _menu = require('./menu');

var _menu2 = _interopRequireDefault(_menu);

var _reset = require('./reset');

var _reset2 = _interopRequireDefault(_reset);

var _zoom = require('./zoom');

var _zoom2 = _interopRequireDefault(_zoom);

var _rotate = require('./rotate');

var _rotate2 = _interopRequireDefault(_rotate);

var _navigation = require('./navigation');

var _navigation2 = _interopRequireDefault(_navigation);

var _spinner = require('./spinner');

var _spinner2 = _interopRequireDefault(_spinner);

var _closeDiv = require('./close-div');

var _closeDiv2 = _interopRequireDefault(_closeDiv);

var _prototype = require('./prototype');

var _prototype2 = _interopRequireDefault(_prototype);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var kuvaify = function kuvaify() {
  var settings = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  this.images = [];
  this.currentIndex = null;
  this.nextIndex = null;
  this.prevIndex = null;
  this.oldIndex = null;
  this.body = document.body;
  this.screenWidth = this.body.clientWidth;
  this.screenHeight = this.body.clientHeight;
  this.closed = false;
  this.systemsReady = false;
  this.options = _setup2.default.opt(settings);
  this.links = _setup2.default.links.call(this);

  this.overlay = _overlay2.default.call(this);
  this.closeDiv = _closeDiv2.default.call(this);
  this.img = _img2.default.call(this);
  this.close = _close2.default.call(this);
  this.menu = _menu2.default.call(this);
  this.reset = _reset2.default.call(this);
  this.zoom = _zoom2.default.call(this);
  this.rotate = _rotate2.default.call(this);
  this.navigation = _navigation2.default.call(this);
  this.spinner = _spinner2.default.call(this);
};

kuvaify.prototype.pushImage = _prototype2.default.pushImage;
kuvaify.prototype.setCurrent = _prototype2.default.setCurrent;

var init = function init(settings) {
  new kuvaify(settings);
};

window.kuvaify = init;

},{"./close":2,"./close-div":1,"./img":3,"./menu":5,"./navigation":6,"./overlay":7,"./prototype":8,"./reset":9,"./rotate":10,"./setup":11,"./spinner":12,"./zoom":13}],5:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var init = function init() {
  var kuvaify = this;
  var button = document.createElement('a');
  var div = document.createElement('div');
  var help = document.createElement('p');

  var append = function append() {
    button.className = 'kuvaify-menu-button';
    button.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50.000001 50.000001"><g stroke="#fff" fill="none" stroke-width="2"><path d="M10 11h30M10 25h30M10 39h30"/></g></svg>';
    div.className = 'kuvaify-menu-div';
    help.className = 'kuvaify-help';
    help.innerHTML = 'Desktop users can use the <strong>left</strong> and <strong>right</strong> keys to navigate; <strong>up</strong> and <strong>down</strong> or <strong>scroll</strong> to zoom; <strong>page up</strong> and <strong>page down</strong> to rotate; <strong>click</strong> and <strong>drag</strong> to move; <strong>home</strong> or <strong>double click</strong> to reset; and <strong>esc</strong> to close.';

    kuvaify.rotate.append();
    kuvaify.zoom.append();
    kuvaify.reset.append();

    if (kuvaify.options.showShortcuts && kuvaify.screenWidth > 1280) {
      div.appendChild(help);
    }

    kuvaify.overlay.element.appendChild(button);
    kuvaify.overlay.element.appendChild(div);
  };

  var visibility = function visibility(what) {
    if (what === 'visible') {
      button.classList.add('visible');
    }
    if (what === 'hidden') {
      button.classList.remove('visible');
      div.classList.remove('visible');
    }
  };

  var click = function click(event) {
    if (!div.classList.contains('visible')) {
      div.classList.add('visible');
    } else {
      div.classList.remove('visible');
    }

    event.preventDefault();
  };

  var divClick = function divClick(event) {
    div.classList.remove('visible');

    event.preventDefault();
  };

  var addEventListeners = function addEventListeners() {
    button.addEventListener('click', click);

    kuvaify.rotate.addEventListeners();
    kuvaify.zoom.addEventListeners();
    kuvaify.reset.addEventListeners();
  };

  var removeEventListeners = function removeEventListeners() {
    button.removeEventListener('click', click);

    kuvaify.rotate.removeEventListeners();
    kuvaify.zoom.removeEventListeners();
    kuvaify.reset.removeEventListeners();
  };

  return {
    div: div,
    append: append,
    visibility: visibility,
    addEventListeners: addEventListeners,
    removeEventListeners: removeEventListeners
  };
};

exports.default = init;

},{}],6:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var init = function init() {
  var kuvaify = this;
  var next = document.createElement('a');
  var prev = document.createElement('a');

  var append = function append() {
    next.className = 'kuvaify-next-button';
    next.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50.000001 50.000001"><path d="M14.467 10l20 15-20 15" fill="none" stroke="#fff" stroke-width="2"/></svg>';
    prev.className = 'kuvaify-prev-button';
    prev.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50.000001 50.000001"><path d="M35.533 10l-20 15 20 15" fill="none" stroke="#fff" stroke-width="2"/></svg>';

    kuvaify.overlay.element.appendChild(next);
    kuvaify.overlay.element.appendChild(prev);
  };

  var visibility = function visibility(what) {
    if (what === 'depends') {
      if (kuvaify.nextIndex === null) {
        next.classList.remove('visible');
      } else {
        next.classList.add('visible');
      }
      if (kuvaify.prevIndex === null) {
        prev.classList.remove('visible');
      } else {
        prev.classList.add('visible');
      }
    }
    if (what === 'hidden') {
      next.classList.remove('visible');
      prev.classList.remove('visible');
    }
  };

  var getNext = function getNext() {
    kuvaify.oldIndex = kuvaify.currentIndex;

    if (kuvaify.nextIndex !== null) {
      kuvaify.img.prepare(kuvaify.nextIndex, 'navigated');
    }
  };

  var getPrev = function getPrev() {
    kuvaify.oldIndex = kuvaify.currentIndex;

    if (kuvaify.prevIndex !== null) {
      kuvaify.img.prepare(kuvaify.prevIndex, 'navigated');
    }
  };

  var nextImg = function nextImg(event) {
    getNext();

    event.preventDefault();
  };

  var prevImg = function prevImg(event) {
    getPrev();

    event.preventDefault();
  };

  var keydown = function keydown(event) {
    if (event.keyCode === 39) {
      getNext(event);
    }
    if (event.keyCode === 37) {
      getPrev(event);
    }
  };

  var addEventListeners = function addEventListeners() {
    next.addEventListener('click', nextImg);
    prev.addEventListener('click', prevImg);

    window.addEventListener('keydown', keydown);
  };

  var removeEventListeners = function removeEventListeners() {
    next.removeEventListener('click', nextImg);
    prev.removeEventListener('click', prevImg);

    window.removeEventListener('keydown', keydown);
  };

  return {
    append: append,
    visibility: visibility,
    addEventListeners: addEventListeners,
    removeEventListeners: removeEventListeners
  };
};

exports.default = init;

},{}],7:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var init = function init() {
  var _this = this;

  var kuvaify = this;
  var element = document.createElement('div');
  var focusStarted = false;

  var focus = function focus(event) {
    if (focusStarted === false) {
      visibility('focused');

      setTimeout(function () {
        visibility('unfocused');

        focusStarted = false;
      }, 2000);
    }

    focusStarted = true;
  };

  var append = function append() {
    element.className = 'kuvaify';
    element.style.transition = 'opacity ' + _this.options.transitionSpeed + 'ms ease, visibility ' + _this.options.transitionSpeed + 'ms ease';

    kuvaify.body.appendChild(element);
  };

  var visibility = function visibility(what) {
    if (what === 'visible') {
      element.classList.add('visible');
    }
    if (what === 'hidden') {
      element.classList.remove('visible');
    }
    if (what === 'focused') {
      element.classList.add('focused');
    }
    if (what === 'unfocused') {
      element.classList.remove('focused');
    }
  };

  var addEventListeners = function addEventListeners() {
    window.addEventListener('mousemove', focus);
  };

  var removeEventListeners = function removeEventListeners() {
    window.removeEventListener('mousemove', focus);
  };

  return {
    element: element,
    append: append,
    visibility: visibility,
    addEventListeners: addEventListeners,
    removeEventListeners: removeEventListeners
  };
};

exports.default = init;

},{}],8:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var pushImage = function pushImage(link) {
  var img = {
    element: document.createElement('img'),
    href: link.pathname,
    smallHref: link.getAttribute('data-kuvaify-small') || null,
    mediumHref: link.getAttribute('data-kuvaify-medium') || null,
    caption: null,
    scale: 1,
    scaleRatio: this.options.zoomRatio,
    rotate: 0,
    offx: 0,
    offy: 0,
    transition: 'width ' + this.options.transitionSpeed + 'ms ease, height ' + this.options.transitionSpeed + 'ms ease, transform ' + this.options.transitionSpeed + 'ms ease, opacity ' + this.options.transitionSpeed + 'ms ease, visibility ' + this.options.transitionSpeed + 'ms ease',
    loaded: false
  };

  img.element.style.transition = img.transition;
  img.element.style.left = null;
  img.element.style.top = null;
  img.element.classList.add('kuvaify-img');

  if (link.getAttribute('data-kuvaify-caption')) {
    img.caption = document.createElement('div');
    img.caption.innerHTML = '<p>' + link.getAttribute('data-kuvaify-caption').replace(/<[^>]+>/ig, '') + '</p>';
    img.caption.className = 'kuvaify-caption';
    img.caption.style.transition = 'opacity ' + this.options.transitionSpeed + 'ms ease';
  }

  this.images.push(img);
};

var setCurrent = function setCurrent(index) {
  var img = this.images[index];

  this.currentIndex = this.images.indexOf(img);

  if (this.images[this.currentIndex + 1]) {
    this.nextIndex = this.currentIndex + 1;
  } else {
    this.nextIndex = null;
  }
  if (this.images[this.currentIndex - 1]) {
    this.prevIndex = this.currentIndex - 1;
  } else {
    this.prevIndex = null;
  }
};

exports.default = {
  pushImage: pushImage,
  setCurrent: setCurrent
};

},{}],9:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var init = function init() {
  var kuvaify = this;
  var element = document.createElement('a');

  var append = function append() {
    element.className = 'kuvaify-reset-button', element.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50.000001 50.000001"><g stroke="#fff" fill="none" stroke-width="2"><path d="M21.62 28.38L10.31 39.69M12 28h10v10"/><g><path d="M28.38 21.62L39.69 10.31M38 22H28V12"/></g></g></svg>';

    kuvaify.menu.div.appendChild(element);
  };

  var click = function click(event) {
    kuvaify.img.reset(kuvaify.currentIndex);

    event.preventDefault();
  };

  var keydown = function keydown(event) {
    if (event.keyCode === 36) {
      click(event);
    }
  };

  var dblclick = function dblclick(event) {
    event.preventDefault();
  };

  var addEventListeners = function addEventListeners() {
    element.addEventListener('click', click);
    element.addEventListener('dblclick', dblclick);

    window.addEventListener('keydown', keydown);
  };

  var removeEventListeners = function removeEventListeners() {
    element.removeEventListener('click', click);
    element.removeEventListener('dblclick', dblclick);

    window.removeEventListener('keydown', keydown);
  };

  return {
    append: append,
    addEventListeners: addEventListeners,
    removeEventListeners: removeEventListeners
  };
};

exports.default = init;

},{}],10:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var init = function init() {
  var kuvaify = this;
  var negative = document.createElement('a');
  var positive = document.createElement('a');

  var append = function append() {
    negative.className = 'kuvaify-rotate-negative-button', negative.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50.000001 50.000001"><g stroke="#fff" fill="none" stroke-width="2"><path d="M25 39c7.732 0 14-6.268 14-14s-6.268-14-14-14-14 6.268-14 14" stroke-linejoin="round"/><path d="M5.03 17.885l5.565 8.308 8.308-5.567"/></g></svg>';
    positive.className = 'kuvaify-rotate-positive-button', positive.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50.000001 50.000001"><g stroke="#fff" fill="none" stroke-width="2"><path d="M25 39c-7.732 0-14-6.268-14-14s6.268-14 14-14 14 6.268 14 14" stroke-linejoin="round"/><path d="M44.97 17.885l-5.565 8.308-8.308-5.567"/></g></svg>';

    kuvaify.menu.div.appendChild(negative);
    kuvaify.menu.div.appendChild(positive);
  };

  var negativeRotate = function negativeRotate(event) {
    kuvaify.img.transform(kuvaify.currentIndex, {
      rotate: kuvaify.images[kuvaify.currentIndex].rotate - 90
    });

    event.preventDefault();
  };

  var positiveRotate = function positiveRotate(event) {
    kuvaify.img.transform(kuvaify.currentIndex, {
      rotate: kuvaify.images[kuvaify.currentIndex].rotate + 90
    });

    event.preventDefault();
  };

  var keydown = function keydown(event) {
    if (event.keyCode === 33) {
      positiveRotate(event);
    }
    if (event.keyCode === 34) {
      negativeRotate(event);
    }
  };

  var dblclick = function dblclick(event) {
    event.preventDefault();
  };

  var addEventListeners = function addEventListeners() {
    negative.addEventListener('click', negativeRotate);
    positive.addEventListener('click', positiveRotate);
    negative.addEventListener('dblclick', dblclick);
    positive.addEventListener('dblclick', dblclick);

    window.addEventListener('keydown', keydown);
  };

  var removeEventListeners = function removeEventListeners() {
    negative.removeEventListener('click', negativeRotate);
    positive.removeEventListener('click', positiveRotate);
    negative.removeEventListener('dblclick', dblclick);
    positive.removeEventListener('dblclick', dblclick);

    window.removeEventListener('keydown', keydown);
  };

  return {
    append: append,
    addEventListeners: addEventListeners,
    removeEventListeners: removeEventListeners
  };
};

exports.default = init;

},{}],11:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var opt = function opt(settings) {
  var options = {
    linkElement: 'body',
    fileTypes: ['jpg', 'jpeg', 'png', 'gif'],
    coverScreen: true,
    showShortcuts: true,
    transitionSpeed: 400,
    transitionOverlap: 0,
    transitionScale: 0.02,
    zoomRatio: 0.2,
    smallSize: 768,
    mediumSize: 1280
  };

  if (settings.linkElement) {
    if (typeof settings.linkElement === 'string') {
      options.linkElement = settings.linkElement;
    }
  }
  if (settings.fileTypes) {
    if (settings.fileTypes.constructor === Array && settings.fileTypes.length > 0) {
      options.fileTypes = settings.fileTypes;
    }
  }
  if (settings.coverScreen !== undefined) {
    if (settings.coverScreen === false) {
      options.coverScreen = false;
    }
  }
  if (settings.showShortcuts !== undefined) {
    if (settings.showShortcuts === false) {
      options.showShortcuts = false;
    }
  }
  if (settings.transitionSpeed !== undefined) {
    if (typeof settings.transitionSpeed === 'number' && settings.transitionSpeed >= 0) {
      options.transitionSpeed = settings.transitionSpeed;
    }
  }
  if (settings.transitionOverlap !== undefined) {
    if (typeof settings.transitionOverlap === 'number' && settings.transitionOverlap >= 0 && settings.transitionOverlap <= 1) {
      options.transitionOverlap = settings.transitionOverlap;
    }
  }
  if (settings.transitionScale !== undefined) {
    if (typeof settings.transitionScale === 'number') {
      options.transitionScale = settings.transitionScale;
    }
  }
  if (settings.zoomScale !== undefined) {
    if (typeof settings.zoomScale === 'number') {
      options.zoomScale = settings.zoomScale;
    }
  }
  if (settings.smallSize) {
    if (typeof settings.smallSize === 'number') {
      options.smallSize = settings.smallSize;
    }
  }
  if (settings.mediumSize) {
    if (typeof settings.mediumSize === 'number') {
      options.mediumSize = settings.mediumSize;
    }
  }

  return options;
};

var links = function links() {
  var _this = this;

  var linksCollection = document.querySelectorAll(this.options.linkElement + ' a');
  var links = [].slice.call(linksCollection);
  var fileTypes = this.options.fileTypes.join('|');
  var regex = new RegExp('\.(' + fileTypes + ')$');

  links.forEach(function (link) {
    _this.pushImage(link);

    link.addEventListener('click', function (event) {
      var index = links.indexOf(link);

      _this.overlay.append();
      _this.closeDiv.append();
      _this.close.append();
      _this.menu.append();
      _this.navigation.append();
      _this.spinner.append();

      setTimeout(function () {
        _this.overlay.visibility('visible');
        _this.close.visibility('visible');
        _this.menu.visibility('visible');
        _this.navigation.visibility('depends');
      }, 50);

      setTimeout(function () {
        _this.closed = false;

        _this.overlay.addEventListeners();
        _this.closeDiv.addEventListeners();
        _this.close.addEventListeners();
        _this.menu.addEventListeners();
        _this.navigation.addEventListeners();

        _this.img.prepare(index);
      }, _this.options.transitionSpeed + 50);

      setTimeout(function () {
        _this.systemsReady = true;
      }, _this.options.transitionSpeed * 2);

      event.preventDefault();
    });
  });

  return links;
};

exports.default = {
  opt: opt,
  links: links
};

},{}],12:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var init = function init() {
  var kuvaify = this;
  var element = document.createElement('div');

  var append = function append() {
    element.className = 'kuvaify-spinner';
    element.innerHTML = '<div class="sk-folding-cube"><div class="sk-cube1 sk-cube"></div><div class="sk-cube2 sk-cube"></div><div class="sk-cube4 sk-cube"></div><div class="sk-cube3 sk-cube"></div></div>';
    element.style.transition = 'opacity ' + kuvaify.options.transitionSpeed + 'ms ease, visibility ' + kuvaify.options.transitionSpeed + 'ms ease';

    kuvaify.overlay.element.appendChild(element);
  };

  var visibility = function visibility(what) {
    if (what === 'visible') {
      element.classList.add('visible');
    }
    if (what === 'hidden') {
      element.classList.remove('visible');
    }
  };

  return {
    append: append,
    visibility: visibility
  };
};

exports.default = init;

},{}],13:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var init = function init() {
  var kuvaify = this;
  var _out = document.createElement('a');
  var _in = document.createElement('a');

  var append = function append() {
    _out.className = 'kuvaify-zoom-out-button', _out.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50.000001 50.000001"><path d="M40 25H10" fill="none" stroke="#fff" stroke-width="2"/></svg>';
    _in.className = 'kuvaify-zoom-in-button', _in.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50.000001 50.000001"><g fill="none" stroke="#fff" stroke-width="2"><path d="M25 40V10M40 25H10"/></g></svg>';

    kuvaify.menu.div.appendChild(_out);
    kuvaify.menu.div.appendChild(_in);
  };

  var zoomOut = function zoomOut(event) {
    var img = kuvaify.images[kuvaify.currentIndex];

    if (img.scale >= 0.001) {
      img.scale -= img.scaleRatio;
    }

    kuvaify.img.transform(kuvaify.currentIndex, {
      scale: img.scale
    });

    event.preventDefault();
  };

  var zoomIn = function zoomIn(event) {
    var img = kuvaify.images[kuvaify.currentIndex];

    img.scale += img.scaleRatio;

    kuvaify.img.transform(kuvaify.currentIndex, {
      scale: img.scale
    });

    event.preventDefault();
  };

  var keydown = function keydown(event) {
    if (event.keyCode === 38) {
      zoomIn(event);
    }
    if (event.keyCode === 40) {
      zoomOut(event);
    }
  };

  var dblclick = function dblclick(event) {
    event.preventDefault();
  };

  var addEventListeners = function addEventListeners() {
    _out.addEventListener('click', zoomOut);
    _in.addEventListener('click', zoomIn);
    _out.addEventListener('dblclick', dblclick);
    _in.addEventListener('dblclick', dblclick);

    window.addEventListener('keydown', keydown);
  };

  var removeEventListeners = function removeEventListeners() {
    _out.removeEventListener('click', zoomOut);
    _in.removeEventListener('click', zoomIn);
    _out.removeEventListener('dblclick', dblclick);
    _in.removeEventListener('dblclick', dblclick);

    window.removeEventListener('keydown', keydown);
  };

  return {
    append: append,
    addEventListeners: addEventListeners,
    removeEventListeners: removeEventListeners
  };
};

exports.default = init;

},{}]},{},[4])

